module.exports = __webpack_public_path__ + "img/WeChat.d1528131.png";